import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export const IconPlayEntity = ({ classProps }: PropsWithClassProps<'svg'>) => {
  return (
    <div className={twMerge('border border-gray-650/25', classProps?.root)}>
      <svg
        className={twMerge('h-4 w-4', classProps?.svg)}
        viewBox="0 0 50 49"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M20 18.3578C20 17.5069 20 17.0814 20.1854 16.8469C20.3469 16.6426 20.5938 16.5162 20.8611 16.5009C21.1679 16.4834 21.5378 16.7194 22.2778 17.1914L31.9066 23.3336C32.5179 23.7236 32.8236 23.9186 32.9302 24.1644C33.0233 24.3793 33.0233 24.6207 32.9302 24.8356C32.8236 25.0814 32.5179 25.2764 31.9066 25.6664L22.2778 31.8086C21.5378 32.2806 21.1679 32.5166 20.8611 32.4991C20.5938 32.4838 20.3469 32.3574 20.1854 32.1531C20 31.9186 20 31.4931 20 30.6422V18.3578Z"
            fill="white"
          />
        </g>
      </svg>
    </div>
  );
};
